import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-configuration-detail',
  templateUrl: './configuration-detail.component.html',
  styleUrls: ['./configuration-detail.component.scss'],
})
export class ConfigurationDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
